import React from 'react';
import { browserHistory } from 'react-router';

const FILTER_KEYS = ['email', 'account_type', 'subscription_status'];
const EMAIL_DEBOUNCE_MS = 500;

export default class UserFilters extends React.Component {
    constructor(props) {
        super(props);
        this.state = { email: props.location.query.email || '' };
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
    }

    componentDidUpdate(prevProps) {
        const email = this.props.location.query.email || '';
        if (email !== (prevProps.location.query.email || '') && email !== this.state.email) {
            this.setState({ email });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.emailTimer);
    }

    updateQuery(changes) {
        const query = Object.assign({}, this.props.location.query, changes, { page: 1 });
        Object.keys(query).forEach(key => {
            if (query[key] === '' || query[key] === undefined) delete query[key];
        });
        browserHistory.replace({ pathname: this.props.location.pathname, query });
    }

    onEmailChange(e) {
        const email = e.target.value;
        this.setState({ email });
        clearTimeout(this.emailTimer);
        this.emailTimer = setTimeout(() => this.updateQuery({ email: email.trim() }), EMAIL_DEBOUNCE_MS);
    }

    onSelectChange(e) {
        this.updateQuery({ [e.target.name]: e.target.value });
    }

    clearFilters() {
        clearTimeout(this.emailTimer);
        this.setState({ email: '' });
        this.updateQuery({ email: '', account_type: '', subscription_status: '' });
    }

    renderOptions(options) {
        return Object.keys(options).map(key => (
            <option key={key} value={key}>
                {options[key]}
            </option>
        ));
    }

    render() {
        const { query } = this.props.location;
        const { plans, subscriptionStatuses } = this.props;
        const hasFilters = FILTER_KEYS.some(key => query[key]);

        return (
            <div className="user-filters">
                <form
                    className="pure-form user-filters__form"
                    role="search"
                    autoComplete="off"
                    onSubmit={e => e.preventDefault()}
                >
                    {/* Search-style name/type plus opt-out attributes stop password managers autofilling this */}
                    <input
                        type="search"
                        className="form-control"
                        name="user_filter_query"
                        placeholder="Filter by email"
                        autoComplete="off"
                        data-1p-ignore=""
                        data-lpignore="true"
                        data-bwignore=""
                        data-form-type="other"
                        value={this.state.email}
                        onChange={this.onEmailChange}
                    />
                    <select
                        className="form-control"
                        name="account_type"
                        value={query.account_type || ''}
                        onChange={this.onSelectChange}
                    >
                        <option value="">All account types</option>
                        {this.renderOptions(plans)}
                    </select>
                    <select
                        className="form-control"
                        name="subscription_status"
                        value={query.subscription_status || ''}
                        onChange={this.onSelectChange}
                    >
                        <option value="">All subscription statuses</option>
                        {this.renderOptions(subscriptionStatuses)}
                    </select>
                    {hasFilters ? (
                        <button type="button" className="pure-button" onClick={this.clearFilters}>
                            Clear filters
                        </button>
                    ) : null}
                </form>
            </div>
        );
    }
}
